import React from 'react';
import styles from './page.module.css';

export default function PrivacyHub() {
  return (
    <div className={styles.container}>
      <h1>Privacy Hub</h1>
      <p>Manage your privacy settings</p>
      <div className={styles.content}>
        <p>Privacy controls will go here.</p>
      </div>
    </div>
  );
}
